module.exports = __webpack_public_path__ + "img/hu.e5e334fd.svg";